module.exports = __webpack_public_path__ + "img/icon_mobileApp2.14275c52.png";